module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page wallet"
  }, [_c('mu-refresh-control', {
    attrs: {
      "refreshing": _vm.refreshing,
      "trigger": _vm.trigger
    },
    on: {
      "refresh": _vm.refresh
    }
  }), _vm._v(" "), _c('pageTitle', {
    attrs: {
      "title": "银联券明细"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mycoin"
  }, [_vm._v("\n        我的银联券\n        "), _c('h2', [_vm._v("￥" + _vm._s(_vm.wallet.UnionPayCash))])]), _vm._v(" "), _c('div', {
    staticClass: "demo-refresh-container"
  }, [_c('div', {
    staticClass: "list"
  }, _vm._l((_vm.coinRecords), function(item) {
    return _c('div', {
      staticClass: "item"
    }, [_c('div', {
      staticClass: "date"
    }, [_vm._v("\n                    " + _vm._s(_vm._f("detailDate")(item.operateDate)) + "\n                ")]), _vm._v(" "), _c('div', [_c('span', {
      staticClass: "strong"
    }, [_vm._v(_vm._s(item.moneyOperateComent))]), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "detail"
    }, [_vm._v("备注:" + _vm._s(_vm._f("remark")(item.data)))])]), _vm._v(" "), _c('div', [_c('span', {
      staticClass: "num"
    }, [_vm._v(_vm._s(_vm._f("discount")(item.operateMoney)))])])])
  }), 0)]), _vm._v(" "), _c('loadListTail', {
    attrs: {
      "mainTitle": "暂无银联账户记录",
      "mainIcon": "noDetail",
      "noMore": _vm.loadState.stop,
      "isLoading": _vm.loadState.loading,
      "overZero": _vm.coinRecords.length > 0
    }
  }), _vm._v(" "), (_vm.loadState.loading) ? _c('div', {
    staticClass: "loading"
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/LoadingBest.gif")
    }
  })]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7a3e6116!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/wallet/VISADetail.vue
// module id = 1558
// module chunks = 18